<div  
    [id]="mapID" 
    style="height:100%;width:100%;z-index: 5; text-align: center; margin: auto;" 
    [style.height]='data.height' 
    [style.width]='data.width' >
</div>
